import angular from 'angular';
import { PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES, PARTICIPANTS_MIN_COUNT_FOR_MEDIUM_FRAMES, } from '../../../modules/call/constants';
const PREFERRED_RESOLUTION_FULL = {
    width: 1280,
    height: 720,
};
const PREFERRED_RESOLUTION_MINI = {
    width: 320,
    height: 240,
};
const PREFERRED_RESOLUTION_GALLERY_VIEW_BIG = {
    width: 720,
    height: 480,
};
const PREFERRED_RESOLUTION_GALLERY_VIEW_MEDIUM = {
    width: 480,
    height: 320,
};
const PREFERRED_RESOLUTION_GALLERY_VIEW_SMALL = {
    width: 320,
    height: 240,
};
export class ParticipantVideoFrameService {
    async setPreferredResolutionToFull(stream) {
        this.setPreferredResolution(stream, PREFERRED_RESOLUTION_FULL);
    }
    async setPreferredResolutionToMini(stream) {
        this.setPreferredResolution(stream, PREFERRED_RESOLUTION_MINI);
    }
    async setPreferredResolutionForGalleryView(stream, peopleCount) {
        let resolution;
        if (peopleCount < PARTICIPANTS_MIN_COUNT_FOR_MEDIUM_FRAMES) {
            resolution = PREFERRED_RESOLUTION_GALLERY_VIEW_BIG;
        }
        else if (peopleCount >= PARTICIPANTS_MIN_COUNT_FOR_MEDIUM_FRAMES &&
            peopleCount <= PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES) {
            resolution = PREFERRED_RESOLUTION_GALLERY_VIEW_MEDIUM;
        }
        else if (peopleCount > PARTICIPANTS_MAX_COUNT_FOR_MEDIUM_FRAMES) {
            resolution = PREFERRED_RESOLUTION_GALLERY_VIEW_SMALL;
        }
        this.setPreferredResolution(stream, resolution);
    }
    async updateVideo(stream, element) {
        const videoElement = await stream.videoElementPromise;
        if (videoElement) {
            element
                .getElementsByClassName('call-frames__append-video')[0]
                .appendChild(stream.videoElement);
        }
    }
    setPreferredResolution(stream, preferredResolution) {
        if (stream['subscriber']) {
            stream['subscriber'].setPreferredResolution(preferredResolution);
        }
    }
}
export default angular
    .module('doxy.videoChat.callFrames.participantVideoFrameComponent.service', [])
    .service('participantVideoFrameService', ParticipantVideoFrameService).name;
